import { LogLevel, type Configuration, type RedirectRequest } from '@azure/msal-browser';
import type { AppConfig } from '@/config/env';

export function msalConfiguration(cfg: AppConfig): Configuration {
  return {
    auth: {
      clientId: cfg.entraClientId,
      authority: `https://login.microsoftonline.com/${cfg.entraTenantId}`,
      redirectUri: cfg.redirectUri,
      postLogoutRedirectUri: cfg.redirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
        loggerCallback: () => {},
      },
    },
  };
}

export function loginRequest(cfg: AppConfig): RedirectRequest {
  return {
    scopes: cfg.apiScope ? [cfg.apiScope] : ['openid', 'profile'],
    prompt: 'select_account',
  };
}
